
































import Vue from "vue";
// import Component from 'vue-class-component'
import { Component, Prop } from "vue-property-decorator";
import { Range } from "../../types/NewResults";

// The @Component decorator indicates the class is a Vue component
@Component({
  // All component options are allowed in here
})
export default class RangeGraph extends Vue {
  private maxwidth: number = 265;
  private myRange: number = 0;
  @Prop() private range!: Range;
  private created() {
    this.myRange =
      (this.maxwidth * this.range.range) / this.range.totalPossible;
    console.log("myrange", this.myRange);
  }

  private getGraphColor(range: number) {
    console.log(range);
    if (range < 30) {
      return "#38D17A";
    } else if (range < 60) {
      return "#8FEE9E";
    } else if (range < 90) {
      return "#FFCC00";
    } else if (range < 120) {
      return "#FF8D8D";
    } else {
      return "#F74657";
    }
  }
}
